import { useState, useEffect, useImperativeHandle } from "react";
import { useTranslation } from "next-i18next";
import { Modal, Button } from "antd";
import { clearAuthCookies } from "@/utils/cookie";
import { logout } from "@/api/user";
import { useRouter } from "next/router";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RootState } from "@/store/index";
import defaultSettings from "@/config/settings";
import { setToken as setUserToken, setUserInfo } from "@/store/user";

/**
 * logout confirm modal
 * @param open 是否显示
 * @returns
 */
const LogoutConfirmModal = (props: { onRef: any }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const router = useRouter();
  const [open, setOpen] = useState<boolean>(false);
  const appStore = useAppSelector((state: RootState) => state.app);
  const { isSmallScreen, isMobile } = appStore;
  const { pcModalWidth, mobileModalWidth } = defaultSettings;

  useImperativeHandle(props.onRef, () => {
    return {
      setOpen: setOpen,
    };
  });

  // 退出登录
  const handleLogout = async () => {
    try {
      await logout(); // 调用登出接口
    } catch (error) {
      // 接口失败也必须清本地登录态。原实现用 Promise.all，deleteCookie 在数组构造时
      // 就已同步执行，接口报错也照样清掉；这里保持同一语义，否则登出会「点了没反应」。
      console.error("Logout failed:", error);
    }
    clearAuthCookies();
    dispatch(setUserToken(undefined));
    dispatch(setUserInfo(undefined));
    setOpen(false);
    setTimeout(() => {
      router.push("/");
    }, 100);
  };

  return (
    <Modal
      title={null}
      open={open}
      onCancel={() => {
        setOpen(false);
      }}
      width={isSmallScreen ? mobileModalWidth : pcModalWidth}
      closeIcon={false}
      footer={null}
      centered={isMobile}
      maskClosable={true}
    >
      <div className="flex flex-col items-center">
        <div className="my-4  text-xl">{t("common.logout_confirm")}</div>
        <div className="mb-12">{t("common.please_confirm_logout_cur_account")}</div>
        <div className="mb-2 flex justify-center">
          <Button
            type="primary"
            className="mr-4 min-w-[80px]"
            ghost
            onClick={() => {
              setOpen(false);
            }}
            style={{ height: "36px" }}
          >
            {t("common.cancel")}
          </Button>
          <Button type="primary" className="mr-4 min-w-[80px]" onClick={handleLogout} style={{ height: "36px" }}>
            {t("common.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default LogoutConfirmModal;
